import {
  ObservationsV1InputResponseInput,
  ProvideTaskInputMutation,
  ProvideTaskInputMutationVariables,
  TaskFragment,
  useProvideTaskInputMutation,
  withStandardMutationHook,
} from '@spotify/confidence-graphql';

export const useProvideTaskInput = withStandardMutationHook<
  ProvideTaskInputMutation,
  TaskFragment,
  ProvideTaskInputMutationVariables,
  'provideTaskInput',
  [string, ObservationsV1InputResponseInput]
>(useProvideTaskInputMutation, 'provideTaskInput', (name, inputResponse) => ({
  name,
  inputResponse,
}));
